import React, { ReactElement } from 'react';
import { publicSessionApi } from '../../../../../../../../redux/views/session-view/session/api/publicApi';
import { determineIsApexDemo, getSessionInformationFromSession } from './utils';
import { SessionInformation } from '.';

export function ConnectedPublicSessionInformation({
  accessKey,
  sessionUid,
  versionUid,
}: FetchPublicSessionArgs): ReactElement {
  const { sessionInformation, isError, isLoading, isFetching, isApexDemo } =
    publicSessionApi.endpoints.getPublicSession.useQueryState(
      { accessKey, sessionUid, versionUid },
      {
        selectFromResult: ({ data, isLoading, isFetching, isError }) => ({
          isApexDemo: determineIsApexDemo(data),
          isError,
          isFetching,
          isLoading,
          sessionInformation: getSessionInformationFromSession(data),
        }),
      },
    );

  return (
    <SessionInformation
      sessionInformation={sessionInformation}
      isLoading={isLoading || isFetching}
      isError={isError}
      isApexDemo={isApexDemo}
    />
  );
}
